import moment from 'moment'
import { apiCall } from './restclient'
import { appInsights } from './appInsights'

const hippaEndpoint = 'api/v1/utilities/logs/access'
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export function postHIPAALogMessage(requestBody) {
  // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
  apiCall(hippaEndpoint, 'POST', null, JSON.stringify(requestBody))
    .then(() => {})
    .catch((error) => {
      appInsights.trackEvent({
        name: 'HIPAA Log Error',
        properties: { Message: JSON.stringify(error) },
      })
    })
}

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export const generateLoggPatientChartAccessData = ({ userId, patientId }) => ({
  Message: `Provider [${userId}] opened [${patientId}] patient chart at ${moment
    .utc(new Date())
    .format('YYYY-MM-DDTHH:mm:ss.SSSZ')}`,
  PatientId: patientId,
})

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export const generateLoggVisitsAccessData = ({ userId, visitId, patientId }) => ({
  Message: `Provider [${userId}] opened [${visitId}] visit at ${moment
    .utc(new Date())
    .format('YYYY-MM-DDTHH:mm:ss.SSSZ')}`,
  PatientId: patientId,
})
// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export const generateLoggIntakeFormData = ({ userId, intakeFormId, patientId }) => ({
  Message: `Provider [${userId}] opened [${intakeFormId}] intake form at ${moment
    .utc(new Date())
    .format('YYYY-MM-DDTHH:mm:ss.SSSZ')}`,
  PatientId: patientId,
})
